exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lille-switch[data-v-68209fa4]{display:inline-block}.lille-switch>div[data-v-68209fa4],.lille-switch>span[data-v-68209fa4]{float:left}.lille-switch input[data-v-68209fa4]{display:none}.switch-box[data-v-68209fa4]{width:40px;height:20px;background-color:#13ce66;border-radius:10px;display:flex;align-items:center;padding:0 2px;box-sizing:border-box;cursor:pointer;margin-left:6px}.switch-box.closed[data-v-68209fa4]{background-color:#ff4949}.switch-box span[data-v-68209fa4]{width:16px;height:16px;border-radius:50%;display:inline-block;background-color:#fff;position:absolute;left:22px;transition:.2s}.switch-box span.closed[data-v-68209fa4]{left:2px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-68209fa4","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/packages/switch/lille-switch.vue
// module id = 5
// module chunks = 0